import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import { showErrors, showNotification } from '@/utils/snack';
import { SnackType } from '@/interfaces/snack';
import AppTextField from '@/components/AppTextField.vue';
import AppFormItem from '@/components/AppFormItem.vue';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import { findDealer } from '../DealerList/gql';
import { updateDealer, resetDealerPassword } from './gql';
import AppDialog from '@/components/AppDialog.vue';
Component.registerHooks(['beforeRouteLeave']);

var EditDealer = /*#__PURE__*/function (_Vue) {
  _inherits(EditDealer, _Vue);

  var _super = _createSuper(EditDealer);

  function EditDealer() {
    var _this;

    _classCallCheck(this, EditDealer);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '经销商管理'
    }, {
      text: '经销商',
      to: {
        name: 'DealerList'
      }
    }];
    _this.dealerInput = {
      realname: '',
      phone: '',
      openId: '',
      email: '',
      storeName: '',
      storePhone: '',
      sharingProportion: '0'
    };
    _this.originInput = '';
    _this.dealerId = '';
    _this.applyArea = null;
    _this.disabledActions = true;
    _this.role = sessionStorage.getItem('role');
    _this.resetPwdDialog = {
      show: false,
      title: '重置经销商密码',
      text: '该操作会重置该经销商密码，新密码为该经销商登录账号'
    };
    return _this;
  }

  _createClass(EditDealer, [{
    key: "dealerInputChange",
    value: function dealerInputChange(val) {
      if (JSON.stringify(val) !== this.originInput) {
        this.disabledActions = false;
      } else {
        this.disabledActions = true;
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = this.$route.params.id;
                this.dealerId = id;
                _context.next = 4;
                return this.getDealer();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "getDealer",
    value: function () {
      var _getDealer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result, _result$data$findDeal, realname, user, areas, openId, storeName, storePhone, sharingProportion, typedError;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.query({
                  query: findDealer,
                  variables: {
                    dealerId: +this.dealerId
                  }
                });

              case 3:
                result = _context2.sent;

                if (result) {
                  _result$data$findDeal = result.data.findDealer, realname = _result$data$findDeal.realname, user = _result$data$findDeal.user, areas = _result$data$findDeal.areas, openId = _result$data$findDeal.openId, storeName = _result$data$findDeal.storeName, storePhone = _result$data$findDeal.storePhone, sharingProportion = _result$data$findDeal.sharingProportion;
                  this.breadcrumbs = [{
                    text: '经销商管理'
                  }, {
                    text: '经销商',
                    to: {
                      name: 'DealerList'
                    }
                  }];
                  this.breadcrumbs.push({
                    text: "".concat(realname)
                  });
                  this.dealerInput = {
                    openId: openId || '',
                    realname: realname || '',
                    storeName: storeName || '',
                    storePhone: storePhone || '',
                    email: user.email || '',
                    phone: user.phone || '',
                    sharingProportion: (sharingProportion || 0) + ''
                  };
                  this.originInput = JSON.stringify(this.dealerInput);
                  this.applyArea = areas[0];
                }

                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getDealer() {
        return _getDealer.apply(this, arguments);
      }

      return getDealer;
    }()
  }, {
    key: "submitForm",
    value: function () {
      var _submitForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this$dealerInput, realname, email, storeName, storePhone, phone, sharingProportion, input, result, typedError;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$dealerInput = this.dealerInput, realname = _this$dealerInput.realname, email = _this$dealerInput.email, storeName = _this$dealerInput.storeName, storePhone = _this$dealerInput.storePhone, phone = _this$dealerInput.phone, sharingProportion = _this$dealerInput.sharingProportion;
                input = {
                  realname: realname,
                  email: email,
                  storeName: storeName,
                  storePhone: storePhone,
                  phone: phone
                };

                if (this.role === 'ADMIN' || this.role === 'ROOT') {
                  input.sharingProportion = +sharingProportion;
                }

                _context3.prev = 3;
                _context3.next = 6;
                return this.$apollo.query({
                  query: updateDealer,
                  variables: {
                    dealerId: +this.dealerId,
                    input: input
                  }
                });

              case 6:
                result = _context3.sent;

                if (result) {
                  showNotification({
                    msg: '修改成功！',
                    type: SnackType.Info
                  });
                  this.disabledActions = true;
                  this.$router.go(-1);
                }

                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](3);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 10]]);
      }));

      function submitForm() {
        return _submitForm.apply(this, arguments);
      }

      return submitForm;
    }()
  }, {
    key: "beforeRouteLeave",
    value: function () {
      var _beforeRouteLeave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(to, from, next) {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.disabledActions) {
                  res = confirm('页面修改尚未保存，是否确定要离开？');
                  next(res);
                } else {
                  next();
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function beforeRouteLeave(_x, _x2, _x3) {
        return _beforeRouteLeave.apply(this, arguments);
      }

      return beforeRouteLeave;
    }()
  }, {
    key: "resetPassword",
    value: function resetPassword() {
      this.resetPwdDialog.show = true;
    }
  }, {
    key: "resetPasswordConfirm",
    value: function () {
      var _resetPasswordConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.resetPwdDialog.show = false;
                _context5.prev = 1;
                _context5.next = 4;
                return this.$apollo.mutate({
                  mutation: resetDealerPassword,
                  variables: {
                    dealerId: +this.dealerId
                  }
                });

              case 4:
                result = _context5.sent;

                if (result) {
                  showNotification({
                    msg: '重置成功！',
                    type: SnackType.Info
                  });
                }

                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](1);
                typedError = _context5.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 8]]);
      }));

      function resetPasswordConfirm() {
        return _resetPasswordConfirm.apply(this, arguments);
      }

      return resetPasswordConfirm;
    }()
  }]);

  return EditDealer;
}(Vue);

__decorate([Watch('dealerInput', {
  deep: true
})], EditDealer.prototype, "dealerInputChange", null);

EditDealer = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppFormItem: AppFormItem,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppTextField: AppTextField,
    AppDialog: AppDialog
  }
})], EditDealer);
export default EditDealer;